import connector from 'Utils/connector';
import { getPrimarySectionItems } from 'Webapp/shared/app/redux/selectors/section';
import Magazine from 'Webapp/shared/app/views/section/magazine';

export default connector({
  selectors: {
    items: getPrimarySectionItems,
  },
})(Magazine);
